function getSessionPath(basePath) {
  const id = window.sessionStorage.getItem("idEmpresa");
  return id ? `${basePath}/${id}` : basePath;
}

const routes = [
  {
    path: getSessionPath('/empresaform'),
    name: 'Datos de la Empresa',
    component: () => import('@/views/simpleForms/EmpresaForm.vue'),
    meta: { title: 'Datos de la Empresa' },
    props: route => ({ id: route.params.id || window.sessionStorage.getItem("idEmpresa") })
  },
  {
    path: '/espeempr',
    name: 'Especialidades',
    component: () => import('@/views/forms/EspeEmpr.vue'),
    meta: { title: 'Especialidades de la Empresa' }
  },
  {
    path: '/persona',
    name: 'Personas',
    component: () => import('@/views/forms/Persona.vue'),
    meta: { title: 'Personas' }
  },
  {
    path: '/medico',
    name: 'Médicos',
    component: () => import('@/views/forms/Medico.vue'),
    meta: { title: 'Médicos' }
  },
  {
    path: '/elemempr',
    name: 'Elementos y Tarifario',
    component: () => import('@/views/forms/ElemEmpr.vue'),
    meta: { title: 'Elementos y Tarifario de la Empresa' }
  },
  {
    path: '/interaccionmed',
    name: 'Interacciones med.',
    component: () => import('@/views/forms/InteraccionMed.vue'),
    meta: { title: 'Interacciones med.' }
  },
  {
    path: '/paquete-examen',
    name: 'Paquete exámenes',
    component: () => import('@/views/forms/PaqueteExamen.vue'),
    meta: { title: 'Interacciones med.' }
  }
];

export { routes };
